import React, { useState } from 'react';
import { RegularButton, Typography } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { analyticsUtils } from 'utils';
import { useOptimisedImages } from '@navi-toolbox/hooks';
import { contentWrap, imgStyle, imgWrap, innerWrap, modalOpenerStyle, operationalTextStyle } from './styles';
import { OperationalTimeModal } from '../operational-time-modal/operational-time.modal';
import { ModalContentType } from '../types';
import { DATA_QA_OPERATIONAL_TIME_BUTTON, DATA_QA_OPERATIONAL_TIME_BUTTON_PICTURE } from '../constants';

export type OperationalTimeButtonProps = {
  modalCloseCb?: () => void;
  preOpened?: boolean;
  buttonName: string;
  operationalTime: string;
  title: string;
  imgSrc: string;
  modalContent: ModalContentType;
  gaName: string;
};

export const OperationalTimeButton: React.FC<OperationalTimeButtonProps> = ({
  modalCloseCb,
  preOpened,
  buttonName,
  operationalTime,
  title,
  imgSrc,
  modalContent,
  gaName,
}) => {
  const [modalVisibility, setModalVisibility] = useState<boolean>(preOpened || false);
  const onClick = () => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'shopPage',
      elementName: gaName,
      elementText: title,
    });
    setModalVisibility(true);
  };
  const { t } = useTranslation();
  const rest = {
    w: 40,
    h: 40,
  };
  const imgOptimized = useOptimisedImages({
    sizes: {
      rest,
    },
    src: imgSrc,
  });

  const openHours = `${t('openFrom')} ${operationalTime}`;

  return (
    <>
      <RegularButton
        data-qa={DATA_QA_OPERATIONAL_TIME_BUTTON}
        size="l"
        variant="secondary"
        className={contentWrap}
        onClick={onClick}
      >
        <div className={imgWrap}>
          <picture data-qa={DATA_QA_OPERATIONAL_TIME_BUTTON_PICTURE}>
            <source srcSet={`${imgOptimized.rest?.xx} 2x, ${imgOptimized.rest?.x} 1x`} />
            <img
              alt={`${buttonName} иконка кнопки`}
              className={imgStyle}
              width={rest.w}
              height={rest.h}
              src={imgOptimized.rest?.xx ?? undefined}
              srcSet={`${imgOptimized.rest?.xx} 2x, ${imgOptimized.rest?.x} 1x`}
            />
          </picture>
        </div>
        <div className={innerWrap}>
          <div className={operationalTextStyle}>
            <Typography
              data-qa={`operational-time-button-title-${modalContent.qaName}`}
              size="body_long"
              variant="m"
            >
              {title}
            </Typography>
            <Typography data-qa={`operational-time-button-${modalContent.qaName}`} variant="caption">
              {openHours}
            </Typography>
          </div>
          <div id="modal-opener-wrap" className={modalOpenerStyle}>
            <ChevronRightIcon type="outline" size="l" color="text-primary" />
          </div>
        </div>
      </RegularButton>
      <OperationalTimeModal
        modalVisibility={modalVisibility}
        setModalVisibility={setModalVisibility}
        modalContent={modalContent}
        gaName={gaName}
        closeCb={modalCloseCb}
      />
    </>
  );
};
